import { Dictionary } from '@/localization/dictionary'
import { MenuItem } from './user-menu.types'

export const getMenuItems = (
  dict: Dictionary['navigation'],
  isB2BUser: boolean,
): MenuItem[] => {
  if (!isB2BUser) {
    return [
      {
        href: '/dashboard/account',
        icon: '/icons/people.svg',
        label: dict.userMenu.personalData,
      },
      {
        href: '/dashboard/order-history',
        icon: '/icons/package-check.svg',
        label: dict.userMenu.yourOrder,
      },
      {
        href: '/dashboard/address',
        icon: '/icons/map-pin.svg',
        label: dict.userMenu.yourAddress,
      },
      {
        href: '/wishlist',
        icon: '/icons/heart.svg',
        label: dict.userMenu.wishlist,
      },
      {
        href: '/interests',
        icon: '/icons/bell.svg',
        label: dict.userMenu.subscriptionsAndInterests,
      },
    ]
  }

  return [
    {
      href: '/dashboard/account',
      icon: '/icons/people.svg',
      label: dict.userMenu.personalData,
    },
    {
      href: '/dashboard/order-history',
      icon: '/icons/package-check.svg',
      label: dict.userMenu.yourOrder,
    },
    {
      href: '/benefits',
      icon: '/icons/gift-black.svg',
      label: dict.userMenu.benefits,
    },
    {
      href: '/wishlist',
      icon: '/icons/heart.svg',
      label: dict.userMenu.wishlist,
    },
    {
      href: '/interests',
      icon: '/icons/bell.svg',
      label: dict.userMenu.subscriptionsAndInterests,
    },
    {
      href: '/dashboard/group-information',
      icon: '/icons/sales.svg',
      label: dict.userMenu.salesOverview,
    },
    {
      href: '/dashboard/information-hub',
      icon: '/icons/information-hub.svg',
      label: dict.userMenu.informationHub,
    },
    {
      href: '/dashboard/news',
      icon: '/icons/news.svg',
      label: dict.userMenu.news,
    },
  ]
}
